import { SoapUtils } from "../../../../utils/SoapUtils";

export interface SearchTimeSheet{
    recordId?:                string;
    currency?:                string;
    etypeFilter?:             string;
    statusFilter?:            string;
    chargeFilter?:            string;
    statusGroup?:             string;
    typeOfWorkGroup?:         string;
    activityGroup?:           string;
    projectGroup?:            string;
    folderGroup?:             string;
    masterProjectGroup?:      string;
    masterFolderGroup?:       string;
    userGroup?:               string;
    dayGroup?:                string;
    itmVatGroup?:             string;
    wageTypeGroup?:           string;
    wageFixTypeGroup?:        string;
    priceGroup?:              string;
    priceFilter?:             string;
    userDimension1Group?:     string;
    userDimension2Group?:     string;
    userDimension3Group?:     string;
    contextDimension1Group?:  string;
    contextDimension2Group?:  string;
    contextDimension3Group?:  string;
    limit?:                   number;
    offset?:                  number;
    countOnly?:               string;
    toTime?:                  string;
    fromTime?:                string;
    subFunction?:             string;
    oldStatus?:               string;
    newStatus?:               string;
    typeOfWorkFilter?:        string;
    viewId?:                  string;
    allRecords?:              string;
    treeHandle?:              string;
    customer?:                string;
    provider?:                string;
    wageId?:                  string;
    wageType?:                string;
    wageFixType?:             string;
    reevaluate?:              string;
    orderBy?:                 string;
    workReport?:              string;
    dimension1?:              string;
    dimension2?:              string;
    dimension3?:              string;
    invoiceId?:               string;
    itmVatValue?:             string;
    comments?:                string;
    description?:             string;
    plannedTaskCurrent?:      string;
    searchText?:              string;
    userDimension1?:          string;
    userDimension2?:          string;
    userDimension3?:          string;
    contextDimension1?:       string;
    contextDimension2?:       string;
    contextDimension3?:       string;
    userDimension1Simple?:    string;
    userDimension2Simple?:    string;
    userDimension3Simple?:    string;
    contextDimension1Simple?: string;
    contextDimension2Simple?: string;
    contextDimension3Simple?: string;
    FOLDERS?:                 Folders;
    MASTERFOLDERS?:           Folders;
    USERS?:                   Users;
    SELECTED_ITEMS?:          AdvancedTimesheets;
    TYPESOFWORK?:             Typesofwork;
    ADVANCED_TIMESHEETS?:     AdvancedTimesheets;
    MASSCHANGE?:              Masschange;

}

export interface AdvancedTimesheets {
    ITEM?: Item;
}

export interface Item {
    id?: string;
}

export interface Folders {
    count?:  string;
    FOLDER?: Folder;
}

export interface Folder {
    folderId?:   string;
    projectId?:  string;
    activityId?: string;
}

export interface Masschange {
    changeChargeability?:       string;
    chargeability?:             string;
    changeTypeOfWork?:          string;
    typeOfWorkId?:              string;
    changeContext?:             string;
    folderId?:                  string;
    projectId?:                 string;
    activityId?:                string;
    copyCostToPrice?:           string;
    userDimension1Change?:      string;
    userDimension1ToChange?:    string;
    userDimension2Change?:      string;
    userDimension2ToChange?:    string;
    userDimension3Change?:      string;
    userDimension3ToChange?:    string;
    contextDimension1Change?:   string;
    contextDimension1ToChange?: string;
    contextDimension2Change?:   string;
    contextDimension2ToChange?: string;
    contextDimension3Change?:   string;
    contextDimension3ToChange?: string;
}

export interface Typesofwork {
    TYPEOFWORK?: Item;
}

export interface Users {
    count?: string;
    USER?:  Item;
}

export function toSearchTimeSheetXml(obj: SearchTimeSheet): string {
    var parameters: string = '';

    parameters += SoapUtils.makeNode(obj.recordId, 'recordId');
    parameters += SoapUtils.makeNode(obj.currency, 'currency');
    parameters += SoapUtils.makeNode(obj.etypeFilter, 'etypeFilter');
    parameters += SoapUtils.makeNode(obj.statusFilter, 'statusFilter');
    parameters += SoapUtils.makeNode(obj.chargeFilter, 'chargeFilter');
    parameters += SoapUtils.makeNode(obj.statusGroup, 'statusGroup');
    parameters += SoapUtils.makeNode(obj.typeOfWorkGroup, 'typeOfWorkGroup');
    parameters += SoapUtils.makeNode(obj.activityGroup, 'activityGroup');
    parameters += SoapUtils.makeNode(obj.projectGroup, 'projectGroup');
    parameters += SoapUtils.makeNode(obj.folderGroup, 'folderGroup');
    parameters += SoapUtils.makeNode(obj.masterProjectGroup, 'masterProjectGroup');
    parameters += SoapUtils.makeNode(obj.masterFolderGroup, 'masterFolderGroup');
    parameters += SoapUtils.makeNode(obj.userGroup, 'userGroup');
    parameters += SoapUtils.makeNode(obj.dayGroup, 'dayGroup');
    parameters += SoapUtils.makeNode(obj.itmVatGroup, 'itmVatGroup');
    parameters += SoapUtils.makeNode(obj.wageTypeGroup, 'wageTypeGroup');
    parameters += SoapUtils.makeNode(obj.wageFixTypeGroup, 'wageFixTypeGroup');
    parameters += SoapUtils.makeNode(obj.priceGroup, 'priceGroup');
    parameters += SoapUtils.makeNode(obj.priceFilter, 'priceFilter');
    parameters += SoapUtils.makeNode(obj.userDimension1Group, 'userDimension1Group');
    parameters += SoapUtils.makeNode(obj.userDimension2Group, 'userDimension2Group');
    parameters += SoapUtils.makeNode(obj.userDimension3Group, 'userDimension3Group');
    parameters += SoapUtils.makeNode(obj.contextDimension1Group, 'contextDimension1Group');
    parameters += SoapUtils.makeNode(obj.contextDimension2Group, 'contextDimension2Group');
    parameters += SoapUtils.makeNode(obj.contextDimension3Group, 'contextDimension3Group');
    parameters += SoapUtils.makeNode(obj.limit, 'limit');
    parameters += SoapUtils.makeNode(obj.offset, 'offset');
    parameters += SoapUtils.makeNode(obj.countOnly, 'countOnly');
    parameters += SoapUtils.makeNode(obj.toTime, 'toTime');
    parameters += SoapUtils.makeNode(obj.fromTime, 'fromTime');
    parameters += SoapUtils.makeNode(obj.subFunction, 'subFunction');
    parameters += SoapUtils.makeNode(obj.oldStatus, 'oldStatus');
    parameters += SoapUtils.makeNode(obj.newStatus, 'newStatus');
    parameters += SoapUtils.makeNode(obj.typeOfWorkFilter, 'typeOfWorkFilter');
    parameters += SoapUtils.makeNode(obj.viewId, 'viewId');
    parameters += SoapUtils.makeNode(obj.allRecords, 'allRecords');
    parameters += SoapUtils.makeNode(obj.treeHandle, 'treeHandle');
    parameters += SoapUtils.makeNode(obj.customer, 'customer');
    parameters += SoapUtils.makeNode(obj.provider, 'provider');
    parameters += SoapUtils.makeNode(obj.wageId, 'wageId');
    parameters += SoapUtils.makeNode(obj.wageType, 'wageType');
    parameters += SoapUtils.makeNode(obj.wageFixType, 'wageFixType');
    parameters += SoapUtils.makeNode(obj.reevaluate, 'reevaluate');
    parameters += SoapUtils.makeNode(obj.orderBy, 'orderBy');
    parameters += SoapUtils.makeNode(obj.workReport, 'workReport');
    parameters += SoapUtils.makeNode(obj.dimension1, 'dimension1');
    parameters += SoapUtils.makeNode(obj.dimension2, 'dimension2');
    parameters += SoapUtils.makeNode(obj.dimension3, 'dimension3');
    parameters += SoapUtils.makeNode(obj.invoiceId, 'invoiceId');
    parameters += SoapUtils.makeNode(obj.itmVatValue, 'itmVatValue');
    parameters += SoapUtils.makeNode(obj.comments, 'comments');
    parameters += SoapUtils.makeNode(obj.description, 'description');
    parameters += SoapUtils.makeNode(obj.plannedTaskCurrent, 'plannedTaskCurrent');
    parameters += SoapUtils.makeNode(obj.searchText, 'searchText');
    parameters += SoapUtils.makeNode(obj.userDimension1, 'userDimension1');
    parameters += SoapUtils.makeNode(obj.userDimension2, 'userDimension2');
    parameters += SoapUtils.makeNode(obj.userDimension3, 'userDimension3');
    parameters += SoapUtils.makeNode(obj.contextDimension1, 'contextDimension1');
    parameters += SoapUtils.makeNode(obj.contextDimension2, 'contextDimension2');
    parameters += SoapUtils.makeNode(obj.contextDimension3, 'contextDimension3');
    parameters += SoapUtils.makeNode(obj.userDimension1Simple, 'userDimension1Simple');
    parameters += SoapUtils.makeNode(obj.userDimension2Simple, 'userDimension2Simple');
    parameters += SoapUtils.makeNode(obj.userDimension3Simple, 'userDimension3Simple');
    parameters += SoapUtils.makeNode(obj.contextDimension1Simple, 'contextDimension1Simple');
    parameters += SoapUtils.makeNode(obj.contextDimension2Simple, 'contextDimension2Simple');
    parameters += SoapUtils.makeNode(obj.contextDimension3Simple, 'contextDimension3Simple');
    if(obj.FOLDERS){ 
        parameters += '<FOLDERS>'; 
        parameters += SoapUtils.makeNode(obj.FOLDERS.count, 'count');
        if(obj.FOLDERS.FOLDER){
            var folder = obj.FOLDERS.FOLDER;
            if(folder){
                parameters += '<FOLDER>';
                parameters += SoapUtils.makeNode(folder.folderId, 'folderId');
                parameters += SoapUtils.makeNode(folder.projectId, 'projectId');
                parameters += SoapUtils.makeNode(folder.activityId, 'activityId');
                parameters += '</FOLDER>';
            }
        }
        parameters += '</FOLDERS>';
    }
    if(obj.MASTERFOLDERS){ 
        parameters += '<MASTERFOLDERS>'; 
        parameters += SoapUtils.makeNode(obj.MASTERFOLDERS.count, 'count');
        if(obj.MASTERFOLDERS.FOLDER){
            var master_folder = obj.MASTERFOLDERS.FOLDER;
            if(master_folder){
                parameters += '<FOLDER>';
                parameters += SoapUtils.makeNode(master_folder.folderId, 'folderId');
                parameters += SoapUtils.makeNode(master_folder.projectId, 'projectId');
                parameters += SoapUtils.makeNode(master_folder.activityId, 'activityId');
                parameters += '</FOLDER>';
            }
        }
        parameters += '</MASTERFOLDERS>';
    }
    if(obj.USERS){
        parameters += '<USERS>';
        parameters += SoapUtils.makeNode(obj.USERS.count, 'count');
        if(obj.USERS.USER){
            var user = obj.USERS.USER;
            if(user){
                parameters += '<USER>';
                parameters += SoapUtils.makeNode(user.id, 'id');
                parameters += '</USER>';
            }
        }
        parameters += '</USERS>';
    }
    if(obj.SELECTED_ITEMS){
        parameters += '<SELECTED_ITEMS>';
        if(obj.SELECTED_ITEMS.ITEM){
            var item = obj.SELECTED_ITEMS.ITEM;
            if(item){
                parameters += '<ITEM>';
                parameters += SoapUtils.makeNode(item.id, 'id');
                parameters += '</ITEM>';
            }
        }
        parameters += '</SELECTED_ITEMS>';
    }
    if(obj.TYPESOFWORK){
        parameters += '<TYPESOFWORK>';
        if(obj.TYPESOFWORK.TYPEOFWORK){
            var type_of_work = obj.TYPESOFWORK.TYPEOFWORK;
            if(type_of_work){
                parameters += '<TYPEOFWORK>';
                parameters += SoapUtils.makeNode(type_of_work.id, 'id');
                parameters += '</TYPEOFWORK>';
            }
        }
        parameters += '</TYPESOFWORK>';
    }
    if(obj.ADVANCED_TIMESHEETS){
        parameters += '<ADVANCED_TIMESHEETS>';
        if(obj.ADVANCED_TIMESHEETS.ITEM){
            var adv_item = obj.ADVANCED_TIMESHEETS.ITEM;
            if(adv_item){
                parameters += '<ITEM>';
                parameters += SoapUtils.makeNode(adv_item.id, 'id');
                parameters += '</ITEM>';
            }
        }
        parameters += '</ADVANCED_TIMESHEETS>';
    }
    if(obj.MASSCHANGE){
        parameters += '<MASSCHANGE>';
        parameters += SoapUtils.makeNode(obj.MASSCHANGE.changeChargeability, 'changeChargeability');
        parameters += SoapUtils.makeNode(obj.MASSCHANGE.chargeability, 'chargeability');
        parameters += SoapUtils.makeNode(obj.MASSCHANGE.changeTypeOfWork, 'changeTypeOfWork');
        parameters += SoapUtils.makeNode(obj.MASSCHANGE.typeOfWorkId, 'typeOfWorkId');
        parameters += SoapUtils.makeNode(obj.MASSCHANGE.changeContext, 'changeContext');
        parameters += SoapUtils.makeNode(obj.MASSCHANGE.folderId, 'folderId');
        parameters += SoapUtils.makeNode(obj.MASSCHANGE.projectId, 'projectId');
        parameters += SoapUtils.makeNode(obj.MASSCHANGE.activityId, 'activityId');
        parameters += SoapUtils.makeNode(obj.MASSCHANGE.copyCostToPrice, 'copyCostToPrice');
        parameters += SoapUtils.makeNode(obj.MASSCHANGE.userDimension1Change, 'userDimension1Change');
        parameters += SoapUtils.makeNode(obj.MASSCHANGE.userDimension1ToChange, 'userDimension1ToChange');
        parameters += SoapUtils.makeNode(obj.MASSCHANGE.userDimension2Change, 'userDimension2Change');
        parameters += SoapUtils.makeNode(obj.MASSCHANGE.userDimension2ToChange, 'userDimension2ToChange');
        parameters += SoapUtils.makeNode(obj.MASSCHANGE.userDimension3Change, 'userDimension3Change');
        parameters += SoapUtils.makeNode(obj.MASSCHANGE.userDimension3ToChange, 'userDimension3ToChange');
        parameters += SoapUtils.makeNode(obj.MASSCHANGE.contextDimension1Change, 'contextDimension1Change');
        parameters += SoapUtils.makeNode(obj.MASSCHANGE.contextDimension1ToChange, 'contextDimension1ToChange');
        parameters += SoapUtils.makeNode(obj.MASSCHANGE.contextDimension2Change, 'contextDimension2Change');
        parameters += SoapUtils.makeNode(obj.MASSCHANGE.contextDimension2ToChange, 'contextDimension2ToChange');
        parameters += SoapUtils.makeNode(obj.MASSCHANGE.contextDimension3Change, 'contextDimension3Change');
        parameters += SoapUtils.makeNode(obj.MASSCHANGE.contextDimension3ToChange, 'contextDimension3ToChange');
        parameters += '</MASSCHANGE>';

    }
    return parameters;

}